if (!customElements.get('lx-size-guide')) {
  customElements.define('lx-size-guide', class extends HTMLElement {
    get dialog() { return this.querySelector('dialog'); }
    get trigger() { return this.querySelector('[data-size-guide-open]'); }
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('click', (event) => {
        const control = event.target.closest('button');
        if (control?.hasAttribute('data-size-guide-open')) this.open();
        if (control?.hasAttribute('data-size-guide-close')) this.dialog?.close();
        if (control?.dataset.sizeUnit) this.setUnit(control.dataset.sizeUnit);
      }, options);
      this.addEventListener('pointerdown', (event) => {
        this.backdropStart = this.isOutside(event);
      }, options);
      this.addEventListener('click', (event) => {
        if (this.backdropStart && this.isOutside(event)) this.dialog.close();
        this.backdropStart = false;
      }, options);
      this.addEventListener('close', () => this.release(), { ...options, capture: true });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab' || !this.dialog?.open) return;
        const controls = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex="0"]')].filter((element) => element.getClientRects().length);
        const first = controls[0];
        const last = controls.at(-1);
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }, options);
    }
    isOutside(event) {
      if (!this.dialog || event.target !== this.dialog) return false;
      const rect = this.dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    }
    open() {
      if (!this.dialog || this.dialog.open || !this.trigger) return;
      this.returnTarget = document.activeElement;
      this.originalOverflow = document.documentElement.style.overflow;
      this.highlightSelectedSize();
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.locked = true;
      this.trigger.setAttribute('aria-expanded', 'true');
    }
    release() {
      if (!this.locked) return;
      document.documentElement.style.overflow = this.originalOverflow;
      this.locked = false;
      this.trigger?.setAttribute('aria-expanded', 'false');
      if (this.returnTarget?.isConnected) this.returnTarget.focus({ preventScroll: true });
    }
    setUnit(unit) {
      if (!['cm', 'in'].includes(unit)) return;
      this.querySelectorAll('[data-measure-cm]').forEach((cell) => {
        const values = cell.dataset.measureCm.split('|').map(Number);
        if (!values.length || values.some((value) => !Number.isFinite(value))) return;
        cell.textContent = values.map((value) => unit === 'in' ? (value / 2.54).toFixed(1) : String(value)).join(' to ');
      });
      this.querySelectorAll('[data-size-unit]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.sizeUnit === unit)));
      this.querySelectorAll('[data-size-unit-label]').forEach((label) => { label.textContent = unit === 'cm' ? this.dataset.cmLabel : this.dataset.inLabel; });
      const status = this.querySelector('[data-size-guide-status]');
      if (status) status.textContent = unit === 'cm' ? this.dataset.cmStatus : this.dataset.inStatus;
    }
    highlightSelectedSize() {
      const size = this.dataset.selectedSize;
      this.querySelectorAll('tr[data-size-label]').forEach((row) => {
        const selected = Boolean(size && row.dataset.sizeLabel === size);
        row.classList.toggle('lx-sg__selected', selected);
        const label = row.querySelector('[data-selected-size-label]');
        if (label) label.hidden = !selected;
      });
    }
    disconnectedCallback() {
      this.release();
      this.abort?.abort();
    }
  });
}
